import { createSlice } from "@reduxjs/toolkit";

const initialPasoUno = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    id: undefined,
    inscripcionNumero: undefined,
    inscripcionId: undefined,
    responsables: [],
    pasoUnoAlCeroInformacion: undefined,
    error: null
};

export const callTypes = {
    list: "list",
    action: "action"
};


export const pasoUnoSlice = createSlice({
    name: "pasoUno",
    initialState: initialPasoUno,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
 //               state.responsables[action.payload.posicion] = undefined;
            } else {
                state.actionsLoading = false;
  //              state.responsables[action.payload.posicion] = undefined;
            };
        },
        starCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            };
        },
        pasoUnoAlDosFetched: (state, action) => {
            state.actionsLoading = false;
            //state.id = action.payload.pasoUnoAlDosInformacion.id;
            //state.inscripcionNumero = action.payload.pasoUnoAlDosInformacion.inscripcionNumero;
            state.inscripcionId = action.payload.pasoUnoAlDosInformacion.inscripcionId;
            state.responsables = action.payload.pasoUnoAlDosInformacion.responsables;
            state.error = null;
        },
        pasoUnoAlCeroFetched: (state, action) => {
            state.actionsLoading = false;
            state.pasoUnoAlCeroInformacion = action.payload.pasoUnoAlCeroInformacion;
            state.error = null;
        },
        agregarUnResponsable: (state, action) => {
            state.actionsLoading = false;
            state.responsables[action.payload.posicion] = action.payload.responsableInformacion
            state.error = null;
        },
        quitarResponsables: (state, action) => {
            state.actionsLoading = false;
            state.responsables = [];
            state.error = null;
        },
        stateLimpiar: (state, action) => {
            state.actionsLoading = false;
            state.id = undefined;
            state.inscripcionNumero = undefined;
            state.inscripcionId = undefined;
            state.responsables = [];
            state.error = null;
        },
    }
});